import _ from 'lodash'
import QRCode from 'qrcode'
import moment from 'moment'
import * as log from 'loglevel'
import config from '../../config'
const MAX_TITLE = 80
const MAX_TITLE_TIP = 200

function findParaParent(el) {
  if (el.parentElement) {
    if (el.parentElement.tagName === 'P') {
      return el.parentElement
    } else {
      return findParaParent(el.parentElement)
    }
  }
  return null
}

function openingTagLength(el) {
  let o = el.outerHTML
  if (o) {
    let idx = o.indexOf('>')
    if (idx > -1) {
      return o.substring(0, idx + 1).length
    }
  }
  return 0
}

function skipEnd(html, index) {
  let i = index
  if (html.charAt(i - 1) === '>') {
    i--
    while (i >= 0 && html.charAt(i) !== '<') {
      i--
    }
  }
  return i
}

function skipStart(html, index) {
  let i = index
  if (html.charAt(i) === '<') {
    while (i >= 0 && html.charAt(i) !== '>') {
      i++
    }
    i++
  }
  return i
}

function findPrevSiblingsLen(el, root, indices) {
  let len = 0
  let i = 0
  let s = el.previousSibling
  while (s) {
    if (s.nodeType === 3) {
      len += s.textContent.length
    } else {
      let o = s.outerHTML
      if (o) {
        len += o.length
      }
    }
    i += 1
    s = s.previousSibling
  }
  indices.unshift(i)
  let parent = el.parentElement
  if (parent === root) {
    return len
  }
  len += openingTagLength(parent)
  return len + findPrevSiblingsLen(parent, root, indices)
}

function findStartIndex(el, offset, root, indices) {
  let sibling = findPrevSiblingsLen(el, root, indices)
  return sibling + offset
}

let browser = {
  versions: (() => {
    let u
    if (typeof navigator === 'undefined') {
      u = 'This is not a browser'
    } else {
      u = navigator.userAgent.toLowerCase()
    }
    const isAndroid = /android/.test(u)
    const isiPhone = /iphone/.test(u)
    const isChrome = /chrome/.test(u)
    const isFireFox = /firefox/.test(u)
    const isSafari = /version.*safari/.test(u)
    const isOpera = /opera/.test(u)
    const isIE = /msie/.test(u) && !/opera/.test(u)
    const isMobile = isAndroid || isiPhone
    return {
      isMobile,
      isAndroid,
      isiPhone,
      isChrome,
      isFireFox,
      isSafari,
      isOpera,
      isIE
    }
  })(),
  userAgent: (() => {
    let u
    if (typeof navigator === 'undefined') {
      u = 'This is not a browser'
    } else {
      u = navigator.userAgent
    }
    return u
  })(),
  systems: (() => {
    let u
    if (typeof navigator === 'undefined') {
      u = 'This is not a browser'
    } else {
      u = navigator.userAgent.toLowerCase()
    }
    const isWindows = /windows/.test(u)
    const isMac = /mac/.test(u)
    const isUnix = /x11/.test(u)
    const isLinux = /linux/.test(u)
    return { isWindows, isMac, isUnix, isLinux }
  })()
}

let qrCode = {
  /**
   * function to generate qr code image data source
   * @param  {object}  data            the info will be encoded into qr code
   * @param  {object}  params
   * @param  {number}  params.version  symbol's size(1 to 40), higher is the version, more are the storable data, and of course bigger will be the QR Code symbol
   * @param  {number}  params.width    the width of qr code image
   * @return {Promise}                 return the qr code image data source
   */
  generateQRCode: async (data, params = { width: 270 }) => {
    try {
      data = JSON.stringify(data)
      return await QRCode.toDataURL(data, params)
    } catch (err) {
      log.error(err)
      return false
    }
  }
}

const titlize = function(content) {
  let short = content
    .replace(/<img (?:.|\s\S)*?>/g, '')
    .replace(/<table (?:.|\s\S)*?>/g, '')
    .substr(0, MAX_TITLE_TIP)
    .replace(/<(?:.|\n)*?>/gm, '')
    .replace(/<.*/gm, '')
    .replace('\n', '')
  return {
    tip: short + ' ...',
    title:
      short.length <= MAX_TITLE ? short : short.substr(0, MAX_TITLE) + ' ...'
  }
}

export default {
  clean(content) {
    return content.replace(/<(?:.|\n)*?>/gm, '')
  },
  shorten(content) {
    return content
      .substr(0, MAX_TITLE_TIP)
      .replace(/<(?:.|\n)*?>/gm, '')
      .replace(/<.*/gm, '')
      .replace('\n', '')
  },
  findTitle(content) {
    let heading = content.match(/<(h[1-4])>((?:(?!<h\d+\b).)+?)<\/\1>/)
    if (heading) {
      let title = heading[2]
      title = title.replace(/<(?:.|\n)*?>/gm, '')
      title = _.trim(_.replace(title, /&nbsp;/g, ''))
      if (title.length > 0) {
        return title
      }
    }
    let p = content.match(/(<p>)(.*?)(<\/p>)/i)
    if (p) {
      content = p[0]
    }
    return titlize(content).title
  },
  titlize,
  isAuthoredBy(chunk, user) {
    return chunk.author.id === user.id
  },

  setDocumentTitle(title) {
    document.title = title || config.title
  },
  fixContent(originalContent, newContent) {
    newContent = _.trim(newContent)
    if (_.startsWith(originalContent, '<p')) {
      if (_.startsWith(newContent, '<p')) {
        return newContent
      }
      return '<p>' + newContent + '</p>'
    } else {
      if (!_.startsWith(newContent, '<p')) {
        return newContent
      }
      let start = skipStart(newContent, 0)
      let end = skipEnd(newContent, newContent.length)
      return newContent.substring(start, end)
    }
  },
  isOverlap(range1, range2) {
    let x1 = range1[0]
    let y1 = range1[1]
    let x2 = range2[0]
    let y2 = range2[1]
    return x1 < y2 && x2 < y1
  },
  injectHighlighter(content, start, end, operation, klass) {
    start = skipStart(content, start)
    end = skipEnd(content, end)
    klass = klass || 'b-suggestion-highlight'
    let selected = content.substring(start, end)
    if (operation === 'insert') {
      end = start
      selected = '^'
    }
    let contentWithHighlight = content.substring(0, start)
    contentWithHighlight += '<span class="' + klass + '">'
    contentWithHighlight += selected
    contentWithHighlight += '</span>'
    contentWithHighlight += content.substring(end)
    return contentWithHighlight
  },
  getSelectionCharacterOffsetWithin(element) {
    let start = 0
    let end = 0
    let insert = 0
    let doc = element.ownerDocument || element.document
    let win = doc.defaultView || doc.parentWindow
    let sel
    let el1
    let el2
    let el1Para
    let el2Para
    let offset1 = 0
    let offset2 = 0
    let root = element
    let code = ''
    let indices1 = []
    let indices2 = []
    let range
    let rootHTML = root.innerHTML

    if (typeof win.getSelection !== 'undefined') {
      sel = win.getSelection()
      if (sel.rangeCount > 0) {
        range = win.getSelection().getRangeAt(0)

        el1 = range.startContainer
        el2 = range.endContainer
        el1Para = findParaParent(el1)
        el2Para = findParaParent(el2)
        offset1 = range.startOffset
        offset2 = range.endOffset
        root = element
        code = ''

        if (
          el1Para === el2Para && // within the same paragraph
          el1.nodeType === 3 &&
          el2.nodeType === 3 // both text
        ) {
          start = findStartIndex(el1, offset1, root, indices1)
          end = findStartIndex(el2, offset2, root, indices2)
          insert = start // insertion index
          if (rootHTML.charAt(start - 1) === '>') {
            insert = start - 1
            while (insert >= 0 && rootHTML.charAt(insert) !== '<') {
              insert--
            }
            if (rootHTML.charAt(end) === '<') {
              start = insert
              let l = rootHTML.length
              while (end < l && rootHTML.charAt(end) !== '>') {
                end++
              }
              end++
            }
          }
          code = rootHTML.substring(start, end)
        }
      }
    }
    let result = {
      indices1,
      indices2,
      offset1,
      offset2,
      start,
      end,
      insert,
      code
    }
    return result
  },
  browser: browser,
  qrCode: qrCode,
  /**
   * Tagged template literals
   *
   * @param strings
   * @param keys
   * @returns {Function}
   */
  ttl(strings, ...keys) {
    return function(collection) {
      let result = [strings[0]]
      collection = collection || {}
      keys.forEach(function(key, i) {
        result.push(collection[key], strings[i + 1])
      })
      return result.join('')
    }
  },
  formatDate(date) {
    if (date) {
      return moment(date)
        .local()
        .format('MMM D, YYYY HH:mm')
    }
    return '-'
  },
  formatDuration(diff) {
    if (diff) {
      return moment.duration(diff).humanize(true)
    }
    return '-'
  },
  checkDate(date) {
    if (date) {
      date = moment(date)
      if (date.isValid()) {
        return date.utc().valueOf()
      }
    }
    return null
  },
  pluralize: (count, noun, suffix = 's') => `${count} ${noun}${count === 1 ? '' : suffix}`
}
